// export const API_URI = "https://api.nikotan.ir/api";
export const API_URI = "https://devapi.nikotan.ir/api";
// export const API_URI = "http://192.168.8.104:8000/api";
// export const API_URI = "http://127.0.0.1:8000/api";
// export const API_URI = "http://192.168.100.19:8000/api";
// export const API_URI = "http://192.168.100.9:8000/api";
// export const API_URI = "http://192.168.62.47:8000/api";
export const Errors = {
  errorServer: "مشکلی در ارتباط با سرور پیش امده",
};
// questioncategory/store
// questioncategory/store
